export { acceptDefaultOrgTags } from "./AcceptDefaultOrgTags.mutation";
export { addAdminForBillingGroup } from "./AddAdminForBillingGroup.mutation";
export { addOrgTags } from "./AddOrgTags.mutation";
export { addUserTags } from "./AddUserTags.mutation";
export { addAndRemoveOrgTags } from "./AddAndRemoveOrgTags.mutation";
export { addAndRemoveUserTags } from "./AddAndRemoveUserTags.mutation";
export { addManualMembersForBillingGroup } from "./AddManualMembersForBillingGroup.mutation";
export { addSlackAccount } from "./AddSlackAccount.mutation";
export { addSlackAccountV2 } from "./AddSlackAccountV2.mutation";
export { addSlackAccountForTeam } from "./AddSlackAccountForTeam.mutation";
export { addZoomAccount } from "./AddZoomAccount.mutation";
export { batchAddAndRemoveOrgTags } from "./BatchAddAndRemoveOrgTags.mutation";
export { batchModifyAutopilotForEvents } from "./ModifyAutopilotForEvent.mutation";
export { createDataSource } from "./CreateDataSource.mutation";
export { createOrgSubscriptionStripe } from "./CreateOrgSubscriptionStripe.mutation";
export { createTeam } from "./CreateTeam.mutation";
export { createTeamCalendar } from "./CreateTeamCalendar.mutation";
export { createTeamSubscriptionStripe } from "./CreateTeamSubscriptionStripe.mutation";
export { createTeamAndTeamSubscriptionStripe } from "./CreateTeamAndTeamSubscriptionStripe.mutation";
export { deactivateUser } from "./DeactivateUser.mutation";
export { deleteDataSource } from "./DeleteDataSource.mutation";
export { deleteTeam } from "./DeleteTeam.mutation";
export { deleteZoomAccount } from "./DeleteZoomAccount.mutation";
export { disableDataSourceSync } from "./DisableDataSourceSync.mutation";
export { enableDataSourceSync } from "./EnableDataSourceSync.mutation";
export { enableOrDisableTeamSyncForEvent } from "./EnableOrDisableTeamSyncForEvent.mutation";
export { installSlackApp } from "./InstallSlackApp.mutation";
export { invitePersonsToTeam } from "./InvitePersonsToTeam.mutation";
export { inviteToBillingGroup } from "./InviteToBillingGroup.mutation";
export { joinWaitlist } from "./JoinWaitlist.mutation";
export { loginUser } from "./LoginUser.mutation";
export { loginUserChrome } from "./LoginUserChrome.mutation";
export { logoutUser } from "./LogoutUser.mutation";
export { markDefragValueKnobsAsAccepted } from "./MarkDefragValueKnobsAsAccepted.mutation";
export { markDefragValueKnobsAsPresented } from "./MarkDefragValueKnobsAsPresented.mutation";
export { markDefragValueKnobsAsDismissed } from "./MarkDefragValueKnobsAsDismissed.mutation";
export { markSeenFeedSuggestion } from "./MarkSeenFeedSuggestion.mutation";
export { maybeOnboardOrg } from "./MaybeOnboardOrg.mutation";
export { overrideSyncStatusForUserEvent } from "./OverrideSyncStatusForUserEvent.mutation";
export { patchBillingGroup } from "./PatchBillingGroup.mutation";
export { preAddOrgTags } from "./pre-add-org-tags.mutation";
export { recordChromeInstall } from "./RecordChromeInstall.mutation";
export { recordChromeUninstall } from "./RecordChromeUninstall.mutation";
export type { IDefragResponseKey } from "./RecordDefragResponse.d";
export { recordDefragResponse } from "./RecordDefragResponse.mutation";
export { recordImpression } from "./RecordImpression.mutation";
export { removeAdminForBillingGroup } from "./RemoveAdminForBillingGroup.mutation";
export { removeGoal } from "./RemoveGoal.mutation";
export { removeLunchHold } from "./RemoveLunchHold.mutation";
export { removeManualMembersForBillingGroup } from "./RemoveManualMembersForBillingGroup.mutation";
export { removeOrgTags } from "./RemoveOrgTags.mutation";
export { removeUserTags } from "./RemoveUserTags.mutation";
export { rescheduleEventParent } from "./RescheduleEventParent.mutation";
export { saveAsanaCredentials } from "./SaveAsanaCredentials.mutation";
export { saveTeamSettings } from "./SaveTeamSettings.mutation";
export { saveTeamUserSettings } from "./SaveTeamUserSettings.mutation";
export { scheduleNewEvent } from "./ScheduleNewEvent.mutation";
export { scheduleNewSmartHold } from "./ScheduleNewSmartHold.mutation";
export { saveUserSurveyResponses } from "./SaveUserSurveyResponseWrapper.mutation";
export { saveUninstallResponse } from "./SaveUninstallResponse.mutation";
export { sendBillingGroupRequestEmail } from "./SendBillingGroupRequestEmail.mutation";
export { setPreferredRooms } from "./SetPreferredRooms.mutation";
export { setPrimaryTeam } from "./SetPrimaryTeam.mutation";
export { setWorkAddressForUser } from "./SetWorkAddressForUser.mutation";
export { sudoDeactivateUser } from "./SudoDeactivateUser.mutation";
export { sudoDeleteEverything } from "./SudoDeleteEverything.mutation";
export { sudoResetFlowState } from "./SudoResetFlowState.mutation";
export { sudoSwitchUser } from "./SudoSwitchUser.mutation";
export { sudoTriggerClientUpdate } from "./SudoTriggerClientUpdate.mutation";
export { triggerDefragRun } from "./TriggerDefragRun.mutation";
export { unpauseEvent } from "./UnpauseEvent.mutation";
export { unsubscribeEmail } from "./UnsubscribeEmail.mutation";
export { updateEventColoringSettings } from "./UpdateEventColoringSettings.mutation";
export { updateToggleEventColoringSettings } from "./UpdateToggleEventColoringSettings.mutation";
export { updateFlowStateUser } from "./UpdateFlowStateUser.mutation";
export { updateOrgInvite } from "./UpdateOrgInvite.mutation";
export { updateSetting } from "./UpdateSetting.mutation";
export { updateSmartHoldSyncSettings } from "./UpdateSmartHoldSyncSettings.mutation";
export { updateSlackAccountForTeam } from "./UpdateSlackAccountForTeam.mutation";
export { updateSuggestedOrgInvite } from "./UpdateSuggestedOrgInvite.mutation";
export { updateUserDefinedTeam } from "./UpdateUserDefinedTeam.mutation";
export { updateWorkingHours } from "./UpdateWorkingHours.mutation";
export { upsertEmailTriage } from "./UpsertEmailTriage.mutation";
export { updateFlagsForUser } from "./UpdateFlagsForUser.mutation";
export { upsertFocusTime } from "./UpsertFocusTime.mutation";
export { upsertLunch } from "./UpsertLunch.mutation";
export { upsertPreferredWork } from "./UpsertPreferredWork.mutation";
export { upsertMeetingRelief } from "./UpsertMeetingRelief.mutation";
export { upsertNonUserDefragEmailResponse } from "./UpsertNonUserDefragEmailResponse.mutation";
export { updateTeam } from "./UpdateTeam.mutation";
export { upsertTravelTime } from "./UpsertTravelTime.mutation";
export { unsyncFocusTimeEvent } from "./UnsyncFocusTimeEvent.mutation";
export { validateSlackChannelBySendingMessage } from "./ValidateSlackChannelBySendingMessage.mutation";
export { weeklySummaryResponse } from "./WeeklySummaryResponse.mutation";
